import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { logout } from '../../store/slices/authSlice';
import { CaretDownFill } from 'react-bootstrap-icons';
import { HelpOutline as SupportIcon, AccountCircle as AccountIcon } from '@mui/icons-material';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import Logo from '../../components/Logo/logo';
import useAuthMiddleware from '../../useAuthMiddleware';
import StationGroups from '../../Pages/Dashboard/StationGroups/StationGroups';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/dashboard.css';

/**
 * Minimal layout for Station Groups (group_admin): no header. Content only.
 */
const StationGroupsLayout = () => {
  const { loading } = useAuthMiddleware();
  const dispatch = useDispatch();
  const { user, otherUser } = useSelector((state) => state.auth);
  const userIsGroupAdmin = (user?.attributes?.roles || []).includes('group_admin');
  const otherUserIsGroupAdmin = (otherUser?.attributes?.roles || []).includes('group_admin');
  const isGroupAdmin = userIsGroupAdmin || otherUserIsGroupAdmin;
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center min-vh-100"
        style={{ background: '#f5f5f5' }}
      >
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="station-groups-layout min-vh-100" style={{ background: '#f5f5f5' }}>
      <nav
        className="dashboard-navbar"
        style={{ borderBottom: `5px solid ${user?.attributes?.stationTheme || ''}` }}
      >
        <div className="navbar-content">
          <div className="navbar-logo">
            <img
              src={user?.attributes?.stationLogo || "logo"}
              alt="Station Logo"
              className="logo-image"
            />
          </div>
          <div className="flex-grow-1 d-flex justify-content-center">
            <Link
              to="/admin/station-groups"
              className="btn btn-sm btn-outline-primary d-flex align-items-center me-3"
              style={{ minWidth: "120px" }}
            >
              <SwapHorizIcon fontSize="small" className="me-1" />
              Switch station
            </Link>
          </div>
          <div className="navbar-user">
            <div className="d-flex align-items-center">
              <span className="me-2">
                {user?.attributes?.firstName} {user?.attributes?.lastName ? user?.attributes?.lastName.split('')[0] : ''}
              </span>
              <div className="dropdown">
                <button
                  className="btn dropdown-toggle d-flex align-items-center"
                  type="button"
                  onClick={() => setDropdownOpen((prev) => !prev)}
                  style={{ background: 'transparent', border: 'none', padding: 0 }}
                >
                  <div
                    className="rounded-circle bg-secondary text-white text-center d-flex justify-content-center align-items-center me-1"
                    style={{ width: '35px', height: '35px', lineHeight: '35px', cursor: 'pointer' }}
                  >
                    {user?.attributes?.lastName ? user.attributes.lastName.charAt(0) : 'G'}
                  </div>
                  {/* <CaretDownFill size={12} /> */}
                </button>
                {isDropdownOpen && (
                  <ul
                    className="dropdown-menu show"
                    style={{ position: 'absolute', right: 0, left: 'auto' }}
                  >
                    <li>
                      <button
                        className="dropdown-item d-flex justify-content-between align-items-center"
                        onClick={() => dispatch(logout())}
                      >
                        <span>Logout</span>
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
      {isGroupAdmin ? (
        <div className="dashboard-body">
          <div className="sidebar-container">
            <div className="Sidebar">
              <div>
                <nav className="sidebar-nav">
                  <ul className="nav-list">
                    <li className="nav-item">
                      <NavLink
                        to="/admin/group-admin/account/contact"
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                      >
                        <AccountIcon className="nav-icon" />
                        <span className="nav-label">Account</span>
                      </NavLink>
                    </li>
                    <li className="nav-item">
                      <NavLink
                        to="/admin/group-admin/support"
                        className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                      >
                        <SupportIcon className="nav-icon" />
                        <span className="nav-label">Support</span>
                      </NavLink>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="sidebar-bottom">
                Powered by
                <strong>
                  <Logo />
                </strong>
              </div>
            </div>
          </div>
          <div className="dashboard-main" id="main-content">
            <main className="p-4">
              <StationGroups />
            </main>
          </div>
        </div>
      ) : (
        <main className="p-4">
          <StationGroups />
        </main>
      )}
    </div>
  );
};

export default StationGroupsLayout;
